/* eslint-disable prettier/prettier */
import React from "react";

const Complete = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2735 4.53673C11.0303 4.34476 10.6719 4.39592 10.4799 4.63914C10.288 4.88235 10.3391 5.24074 10.5823 5.43272C11.6191 6.23914 12.208 7.44236 12.208 8.74791C12.2079 11.0647 10.3135 12.9463 7.99677 12.9463C5.68004 12.9463 3.78557 11.0647 3.78557 8.74791C3.78557 6.54631 5.50074 4.72872 7.66397 4.56232L7.13914 5.08714C6.92156 5.30473 6.92156 5.66312 7.13914 5.88072C7.25432 5.99589 7.39512 6.04714 7.53592 6.04714C7.67672 6.04714 7.81752 5.99598 7.9327 5.88072L9.4303 4.38312C9.53271 4.2807 9.59673 4.13989 9.59673 3.98634C9.59673 3.83278 9.53271 3.69196 9.4303 3.58956L7.9327 2.07921C7.71511 1.86162 7.35672 1.86162 7.13912 2.07921C6.92152 2.2968 6.92153 2.65518 7.13912 2.87278L7.68948 3.42314C4.89908 3.58957 2.67188 5.90634 2.67188 8.74794C2.67188 11.6919 5.06548 14.0727 7.99668 14.0727C10.9279 14.0727 13.3215 11.6791 13.3215 8.74794C13.3215 7.08391 12.5791 5.56074 11.2734 4.53674L11.2735 4.53673Z"
      fill="#59C376"
    />
    <path
      d="M7.4064 9.18397L6.52317 8.30075C6.30559 8.08316 5.9472 8.08316 5.7296 8.30075C5.51201 8.51834 5.51201 8.87673 5.7296 9.09433L7.0096 10.3743C7.11201 10.4767 7.25282 10.5408 7.40638 10.5408C7.55993 10.5408 7.70075 10.4767 7.80315 10.3743L10.2608 7.91673C10.4783 7.69914 10.4783 7.34075 10.2608 7.12315C10.0432 6.90556 9.68477 6.90556 9.46717 7.12315L7.4064 9.18397Z"
      fill="#59C376"
    />
  </svg>
);

export default Complete;
